import routerMiddleware from './routerMiddleware';
import confirmPhoneMiddleware from './userMiddleware';

export default [routerMiddleware, confirmPhoneMiddleware];
